<template>
    <div class="contents">
        <div class="container-fluid">
            <BirthdayNavigation />
            
            <!-- Alert jika tidak ada add-on birthday -->
            <div v-if="!hasBirthdayAddon" class="row mb-4">
                <div class="col-12">
                    <div class="alert alert-warning d-flex align-items-center" role="alert">
                        <i class="fas fa-exclamation-triangle me-3" style="font-size: 24px;"></i>
                        <div class="flex-grow-1">
                            <h5 class="alert-heading mb-2"><strong>Add-On Birthday Belum Aktif</strong></h5>
                            <p class="mb-2">Anda belum memiliki add-on Birthday / Ulang Tahun. Silakan upgrade paket Anda untuk mengaktifkan fitur ini.</p>
                            <router-link to="/billing" class="btn btn-primary btn-sm">
                                <i class="fas fa-shopping-cart me-2"></i>
                                Upgrade Paket
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Daftar Ulang Tahun
                                </h4>
                            </div>
                        </div>
                        <div v-if="hasBirthdayAddon" class="action-btn">
                            <button v-on:click="retryFailed" class="btn px-15 btn-warning text-white" style="display: inline-flex; margin: 5px">
                                <i class="fas fa-redo fs-16"></i>
                                Kirim Ulang Gagal
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="hasBirthdayAddon" class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <div class="mb-3">
                            <label>Filter:</label>
                            <select v-model="filter" @change="loadItems" class="form-control" style="width: 200px; display: inline-block; margin-left: 10px;">
                                <option value="today">Hari Ini</option>
                                <option value="week">Minggu Ini</option>
                                <option value="month">Bulan Ini</option>
                            </select>
                        </div>
                        <BirthdayTable ref="birthdayTable" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BirthdayTable from "@/components/tables/Birthday.vue";
import BirthdayNavigation from "@/components/birthday/Navigation.vue";

export default {
    components: {
        BirthdayTable,
        BirthdayNavigation
    },
    data() {
        return {
            filter: "today"
        };
    },
    computed: {
        hasBirthdayAddon() {
            return this.$store.state.auth.package?.birthday == 1;
        }
    },
    methods: {
        loadItems() {
            this.$refs.birthdayTable.loadItems();
        },
        async retryFailed() {
            try {
                await this.$store.dispatch("birthday/birthday_retry_failed");
                this.$toast.success("Proses kirim ulang dimulai");
                this.loadItems();
            } catch (err) {
                this.$toast.error("Gagal mengirim ulang");
            }
        }
    },
    mounted() {
        if (this.hasBirthdayAddon) {
            this.loadItems();
        }
    }
};
</script>

